import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { UserDto } from '../dto/user.dto'

@Injectable({ providedIn: 'root' })
export class UserHttp {
  private readonly http = inject(HttpClient)
  private static readonly endpoint = environment.baseUrl + '/utilisateurs'

  connectUser(codeChantier?: string): Observable<UserDto> {
    const params = codeChantier ? { codeChantier } : {}
    return this.http.get<UserDto>(UserHttp.endpoint + '/connected-user', { params })
  }
}
